@if (showHead) {
  <div class="sites-head">
    <span class="sites-head-label">Latest Sites</span>
    <div class="btn-row">
      <mc-button
        *permissionGuard="UserPermissions.manageSites.addSiteService"
        variant="link"
        class="btn-row__link-item"
        (click)="addNewSite.emit($event)"
        data-testid="header.right-side.sites-search.add-sites-button"
      >
        <span aria-label="Add new site">+Add New Site</span>
      </mc-button>
    </div>
  </div>
}
<ul aria-label="Sites">
  @for (site of sites; track site.id) {
    <li class="sites-row" (click)="handleSiteClick($event, site)">
      <span class="sites-item">
        <img [attr.alt]="site.host" [src]="iconStaticUrl + site.url" aria-hidden="true" />
        <span class="sites-item__name" data-testid="header.right-side.sites-found.site-name">{{ site.host }}</span>
      </span>

      @if (overviewSiteService.hasIdMismatch(site)) {
        <mc-button size="small" variant="flat" color="accent">
          <span [attr.aria-label]="'Fix site: ' + site.host">Fix Now</span>
        </mc-button>
      }
      @if (!overviewSiteService.hasIdMismatch(site)) {
        <mc-button
          size="small"
          variant="flat"
          color="secondary"
          data-testid="header.right-side.sites-search.manage-site-button"
        >
          @if (site.viewInfo.product === ProductStatus.COMPETITOR) {
            <span>Switch to UserWay</span>
          } @else {
            <span [attr.aria-label]="'Manage site: ' + site.host">Manage</span>
          }
        </mc-button>
      }
    </li>
  }
</ul>
<div class="btn-row btn-row__link">
  <mc-button
    variant="link"
    class="btn-row__link-item"
    (click)="openAccessibilityWidget($event)"
    (blurEvent)="lastElementBlur.emit($event)"
    data-testid="header.right-side.sites-search.all-sites-button"
  >
    <span>Go to all sites</span>
    <mat-icon>chevron_right</mat-icon>
  </mc-button>
</div>
